<template>
    <div>
        <v-row no-gutters style="background-color:white" class="ma-5 pa-5">
            <img src="@/assets/bns.svg" width="100rem"/>
            <v-divider class="mx-5" vertical></v-divider>
            <h1 style="color:#920825">Kezelő felület</h1>
        </v-row>
        <v-row no-gutters class="ma-5">
            <v-card elevation="2" width="100%">
                <v-card-title class="white--text" style="background-color:#920825">Termékek</v-card-title>
                    <v-row no-gutters justify="center">
                        <Product :id="-1"/>
                        <Product 
                            v-for="item in items"
                            :key="item.id"
                            :id="item.id" :type_id="item.type_id" :product_name="item.name" :description="item.description" :index_picture="item.index_picture" admin/>
                    </v-row> 
            </v-card>
        </v-row>
        <v-row>
            <DescriptionEditor/>
        </v-row>
    </div>
</template>

<script>
import Product from '@/components/Product.vue'
import DescriptionEditor from '@/components/DescriptionEditor'
import api from '@/util/api_util'
export default {
    name: 'Dashboard',
    components:{
        Product,
        DescriptionEditor
    },
    data(){
        return{
            items:[]
        }
    },
    created:function(){
        api.post("/item/list").then(response => {
            this.items = response.datas
            console.log(response);     
        });
        
        this.index_pic = ImageUtil.loadImage(this.index_pic);
    }
}
</script>

 <style scoped>
    .product_card{
        width: 400px;
        height: 400px;
        margin: 20px 20px 20px 20px;
    }
 </style>